module.exports = function() {
  return new Worker(__webpack_public_path__ + "c422abf5755065a08586.worker.js");
};